var _metadata, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArretePeril(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1280.000000pt",
    height: "1126.000000pt",
    viewBox: "0 0 1280.000000 1126.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\n    Created by potrace 1.15, written by Peter Selinger 2001-2017\n    ")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "exclamation-mask"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1280,
    height: 1126,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(60.000000,1106.000000) scale(0.0900000,-0.0900000)",
    fill: "black"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6290 7874 c-14 -3 -61 -14 -104 -25 -390 -98 -706 -474 -706 -837 0                 -46 22 -254 50 -461 27 -207 113 -857 190 -1446 201 -1535 199 -1517 216                 -1581 42 -165 141 -297 271 -361 67 -33 86 -38 168 -41 152 -7 246 30 348 136                 99 105 144 224 176 464 11 84 61 462 111 841 49 378 131 996 180 1375 50 378                 100 756 111 840 24 182 25 305 4 387 -82 323 -360 599 -693 686 -75 20 -266                 33 -322 23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6322 2739 c-345 -44 -594 -371 -552 -726 20 -166 86 -301 204 -410                 114 -107 237 -160 391 -170 187 -11 336 47 475 187 134 134 192 273 193 465 1                 116 -13 183 -58 280 -120 261 -379 409 -653 374z"
  }))))), /*#__PURE__*/React.createElement("polyline", {
    points: "50,1076 630,50 1230,1076 50,1076",
    style: {
      fill: "white",
      stroke: "white",
      strokeWidth: 50,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    mask: "url(#exclamation-mask)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArretePeril);
export default __webpack_public_path__ + "static/media/arrete-peril.fee54933102f43570fe5ef29eba33055.svg";
export { ForwardRef as ReactComponent };